import { Facebook, Instagram } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-background py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-serif font-bold mb-4">LVK Haldus OÜ</h3>
            <p className="text-background/70 mb-6 max-w-md leading-relaxed">
              Kinnisvara haldus- ja hooldusteenus ettevõtetele, korteriühistutele ja eraisikutele. 
              Pakume professionaalset kinnisvarahalduse täisteenust.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/lvkhaldus"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-background/10 flex items-center justify-center hover:bg-accent hover:text-accent-foreground transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/lvkhaldus"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-background/10 flex items-center justify-center hover:bg-accent hover:text-accent-foreground transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Kiirlingid</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-background/70 hover:text-accent transition-colors duration-300">
                  Teenused
                </a>
              </li>
              <li>
                <a href="#team" className="text-background/70 hover:text-accent transition-colors duration-300">
                  Meeskond
                </a>
              </li>
              <li>
                <a href="#contact" className="text-background/70 hover:text-accent transition-colors duration-300">
                  Kontakt
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Kontakt</h4>
            <ul className="space-y-3 text-background/70">
              <li>Teenindame üle Eesti</li>
              <li>
                <span className="text-background/50 text-sm">Äriklient:</span>{" "}
                <a href="tel:+37253855694" className="hover:text-accent transition-colors">+372 5385 5694</a>
              </li>
              <li>
                <span className="text-background/50 text-sm">Eraklient:</span>{" "}
                <a href="tel:+37256270634" className="hover:text-accent transition-colors">+372 5627 0634</a>
              </li>
              <li>info@lvkhaldus.ee</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-background/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-background/50 text-sm">
            © {currentYear} LVK Haldus OÜ. Kõik õigused kaitstud.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-background/50 hover:text-background transition-colors duration-300">
              Privaatsuspoliitika
            </a>
            <a href="#" className="text-background/50 hover:text-background transition-colors duration-300">
              Kasutustingimused
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
